module.exports = __webpack_public_path__ + "img/astrogator.592b5ad0.jpg";